import { useEffect } from "react";

import Main from '../components/AboutUs/Main'
import WhyConsulting from "../components/AboutUs/WhyConsulting";
import OurMission from "../components/AboutUs/OurMission";
import OurValues from "../components/AboutUs/OurValues";
import Footer from '../components/Footer'

function AboutUs () {
 
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
      
    return(
        <div className="bg-[#FFFFFF]">
            <Main/>
            <WhyConsulting/>
            <OurMission/>
            <OurValues/>
            <Footer />
        </div>
    );
}

export default AboutUs;